export default __webpack_public_path__ + "static/media/financial-card.0fba7523.svg";